const headers = [
    // { id: 'id', label: 'ID' },
    { id: 'documentLabel', label: 'Document Name' },
    { id: 'status', label: 'Status' },
    { id: 'responseStatus', label: 'Response Status' },
    { id: 'requestDocTime', label: 'Request Time' },
    { id: 'responseDocTime', label: 'Response Time' },
    { id: 'comment', label: 'Comment' },
    { id: 'drDocumentReviewComment', label: 'Review Comment' },
    { id: 'drDocumentRejectReason', label: 'Reject Reason' },
    { id: 'link', label: 'Link' }, 
];

const historyMockData = [
    {
        "documentLabel": "ENTRY_SUMMARY_PACKAGE",
        "status": "SENT",
        "responseDocTime": "2025-07-15 18:52:08",

        "requestDocTime": "2025-07-15 18:52:08",
        "comment": "abc_121",
        "completeFileName": "KCBP_20225185135.pdf",
        "fileExtensionType": "pdf",
        "responseStatus": "PASSED",
        "drDocumentReviewComment": "ave",
        "drDocumentRejectReason": "erew"
    }
]

export {headers, historyMockData};